import FormLabel from '../../../base/components/forms/FormLabel';
import FormField from '../../../base/components/forms/FormField';
import SelectList from '../../../base/components/forms/SelectList';
import SearchSelectList from '../../../base/components/forms/SearchSelectList';
import Checkbox from '../../../base/components/forms/Checkbox';
import Radio from '../../../base/components/forms/Radio';
import DateField from '../../../base/components/forms/DateField';
import ValidationMessages from '../../../base/components/forms/ValidationMessages';
import Loader from '../../../base/components/loader/Loader';
import PageLoader from '../../../base/components/page-loader/PageLoader';

export default [
  FormLabel,
  FormField,
  SelectList,
  SearchSelectList,
  Checkbox,
  Radio,
  DateField,
  ValidationMessages,
  Loader,
  PageLoader
];
